// Deprecated対応予定の項目の差替を行う
import {Occupation} from "../domain/model/project";

export const occupationsByDeprecated = (from: Occupation[]): Occupation[] => {

    // 値の変更
    const list: Occupation[] = from.map((item) => {

        if (item === Occupation.Occupation_HumanResource_Deprecate_1) { return Occupation.Occupation_HumanResource; }
        if (item === Occupation.Occupation_HumanResource_Deprecate_2) { return Occupation.Occupation_HumanResource; }
        if (item === Occupation.Occupation_HumanResource_Deprecate_3) { return Occupation.Occupation_HumanResource; }

        if (item === Occupation.Occupation_IPO_Deprecate_1) { return Occupation.Occupation_WebMarketing; }

        if (item === Occupation.Occupation_Finance_Deprecate_1) { return Occupation.Occupation_Finance; }
        if (item === Occupation.Occupation_Finance_Deprecate_2) { return Occupation.Occupation_Finance; }

        return item;
    });

    // 重複値の削除
    return Array.from(new Set(list));

}



// WEBPACK FOOTER //
// ./src/util/depricated.ts